import { Wrapper } from './StubOverPerformance.styles'
import { Box, Typography, Skeleton } from '@mui/material'
import theme from 'theme'

const StubOverPerformance = () => {
  const size = 350
  const radius = size / 2 - 10
  const strokeWidth = 30
  const normalizedRadius = radius - strokeWidth / 2

  return (
    <Wrapper>
      <Box className="title-wrapper">
        <img src="/title-vector.svg" alt="title-vector" />
        <Typography className="chart-title">Overall Program Score</Typography>
      </Box>
      <Box className="last-update-skeleton-wrapper">
        <Skeleton
          variant="text"
          width={230}
          height={32}
          sx={{
            marginLeft: 0,
            borderRadius: '4px'
          }}
        />
      </Box>

      <Box className="chart-container">
        <svg height={200} width={size}>
          <defs>
            <linearGradient id="shimmer-gradient" x1="0%" y1="0%" x2="100%" y2="0%" gradientUnits="objectBoundingBox">
              <stop offset="0%" stopColor={theme.colors.primaryLight} stopOpacity="0.3">
                <animate attributeName="stop-opacity" values="0.3;0.8;0.3" dur="1.5s" repeatCount="indefinite" />
              </stop>
              <stop offset="50%" stopColor={theme.colors.primaryLight} stopOpacity="0.8">
                <animate attributeName="stop-opacity" values="0.8;0.3;0.8" dur="1.5s" repeatCount="indefinite" />
              </stop>
              <stop offset="100%" stopColor={theme.colors.primaryLight} stopOpacity="0.3">
                <animate attributeName="stop-opacity" values="0.3;0.8;0.3" dur="1.5s" repeatCount="indefinite" />
              </stop>
            </linearGradient>
          </defs>

          <path
            d={`M ${strokeWidth / 2},${size / 2} A ${normalizedRadius},${normalizedRadius} 0 0,1 ${
              size - strokeWidth / 2
            },${size / 2}`}
            fill="none"
            stroke="url(#shimmer-gradient)"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />
        </svg>

        <Box className="placeholder-text">
          <Typography className="loading-text">--</Typography>
        </Box>
      </Box>
    </Wrapper>
  )
}

export default StubOverPerformance
